import { ErrorTheme } from "@acin.reactjs/acin-ui/error";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const errorTheme = (theme: DefaultTheme): ComponentCSSStyle<ErrorTheme> => ({
  title: { marginBottom: "20px" },
  primaryButton: {
    root: {
      border: `1px solid ${theme.palette.greys[300]}`,
    },
    hover: {
      root: {
        backgroundColor: theme.palette.greys[200],
      },
      label: {
        color: theme.palette.common.black,
      },
    },
  },
});

export default errorTheme;
